import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "../axios";

const useEditAdminMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (adminData) => {
      const response = await axios.put(`/api/sellerprofile/bop?_id=${adminData._id}`, {
        first_name: adminData.first_name,
        surname: adminData.surname,
        role: adminData.role,
        verify: false,
      });
      return response.data;
    },
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(["admins"]);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export default useEditAdminMutation;
